import { styled } from '@mui/material/styles';

import Page from '@/components/Page/index.ts';
import { competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';
import { LANG } from '@/services/Config.js';

import type { Route } from './+types/LandingPage';
import BoxContainer from './_components/BoxContainer/index.ts';
import CountdownComponent from './_components/CountdownComponent/index.ts';
import Description2Component from './_components/Description2Component/index.ts';
import Description3Component from './_components/Description3Component/index.ts';
import Description4Component from './_components/Description4Component/index.ts';
import Description5Component from './_components/Description5Component/index.ts';
import Description6Component from './_components/Description6Component/index.ts';
import DescriptionComponent from './_components/DescriptionComponent/index.ts';
import Disclaimer from './_components/Disclaimer/index.ts';

const MainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  position: 'relative',
  width: '100%',
  paddingTop: theme.spacing(5),
  background: theme.palette.primary.light,
  minHeight: '800px',
  [theme.breakpoints.down(960)]: {
    minHeight: '900px',
  },
  [theme.breakpoints.down('md')]: {
    minHeight: '700px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '700px',
    alignItems: 'center',
    paddingTop: theme.spacing(0),
  },
  [theme.breakpoints.down(380)]: {
    minHeight: '650px',
  },
}));

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const competition = competitions.find((c) => c.slug === 'march_2024_campaign');
  return {
    winner: competition?.winners[0],
  };
}

const MarchCompetition = ({ loaderData }: Route.ComponentProps) => {
  const { appStrings } = LANG;

  return (
    <Page title={appStrings.MENU.MARCH_2024_COMPETITION}>
      <MainContainer>
        <BoxContainer winner={loaderData.winner} />
        <DescriptionComponent />
        <CountdownComponent />
        <Description2Component />
        <Description3Component />
        <Description4Component />
        <Description5Component />
        <Description6Component />
        <Disclaimer />
      </MainContainer>
    </Page>
  );
};

export default MarchCompetition;
